import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type HFowardArrowIconProps = Partial<SVGIconProps>;

const ForwardArrowIcon = (props: HFowardArrowIconProps) => {
  return (
    <SVGIcon height="17" viewBox="0 0 17 17" width="17" {...props}>
      <path
        d="M13.833 8.5L14.1866 8.14645L14.5401 8.5L14.1866 8.85355L13.833 8.5ZM3.83301 9C3.55687 9 3.33301 8.77614 3.33301 8.5C3.33301 8.22386 3.55687 8 3.83301 8V9ZM10.1866 4.14645L14.1866 8.14645L13.4795 8.85355L9.47945 4.85355L10.1866 4.14645ZM14.1866 8.85355L10.1866 12.8536L9.47945 12.1464L13.4795 8.14645L14.1866 8.85355ZM13.833 9H3.83301V8H13.833V9Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
};

export default ForwardArrowIcon;
